import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardDescription, CardHeader, CardTitle } from './components/ui/card';

const areas = [
  {
    to: '/admin/photos',
    title: 'Photos',
    description: 'Event gallery photos stored in ImageKit.',
  },
  {
    to: '/admin/carousel',
    title: 'Carousel',
    description: 'Homepage banner images and captions.',
  },
  {
    to: '/admin/content',
    title: 'Content',
    description: 'Page copy, team, causes, and other site text.',
  },
  {
    to: '/admin/messages',
    title: 'Messages',
    description: 'Contact form submissions from the public site.',
  },
];

const AdminHome: React.FC = () => {
  return (
    <div>
      <h1 className="tw-text-3xl tw-font-semibold">Overview</h1>
      <p className="tw-mt-2 tw-max-w-2xl tw-text-sm tw-text-muted-foreground">
        Manage the public site from here. Each section is ready for the tools that update that part of the site.
      </p>
      <div className="tw-mt-8 tw-grid tw-gap-4 md:tw-grid-cols-2">
        {areas.map((area) => (
          <Link key={area.to} to={area.to} className="tw-text-foreground tw-no-underline">
            <Card className="tw-h-full hover:tw-bg-muted">
              <CardHeader>
                <CardTitle className="tw-text-xl">{area.title}</CardTitle>
                <CardDescription>{area.description}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AdminHome;
